import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 300 300",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 150,0\n           a 150,150 0 0,1 106.066,256.066\n           l -35.355,-35.355\n           a -100,-100 0 0,0 -70.711,-170.711 z",
      fill: "#3d7fe6"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        from: "0 150 150",
        to: "360 150 150",
        begin: "0s",
        dur: "1s",
        fill: "freeze",
        repeatCount: "indefinite"
      })
    ], -1)
  ]))]))
}
export default { render: render }